import React, { useState, useEffect } from "react";
import { FiCheck, FiSave, FiLayout, FiEye, FiZap } from "react-icons/fi";
import InvoiceOne from "./InvoiceOne";
import InvoiceTwo from "./InvoiceTwo";
import InvoiceThree from "./InvoiceThree";
import InvoiceFour from "./InvoiceFour";
import InvoiceFive from "./InvoiceFive";
import InvoiceSix from "./InvoiceSix";
import InvoiceSeven from "./InvoiceSeven";
import Topbar from "../../component/Topbar";
import Sidebar from "../../component/Sidebar";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../baseurl";

/* ─── INLINE CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

.is__wrap * { box-sizing: border-box; margin: 0; padding: 0; }

/* ══════════════════════════════════════
   PAGE LAYOUT
══════════════════════════════════════ */
.is__page {
  font-family: 'DM Sans', sans-serif;
  display: flex;
  gap: 0;
  min-height: calc(100vh - 62px);
  background: #eef6f6;
}

/* ══════════════════════════════════════
   LEFT PANEL — sticky sidebar
══════════════════════════════════════ */
.is__panel {
  width: 300px;
  flex-shrink: 0;
  background: #ffffff;
  border-right: 1px solid rgba(10,85,86,0.09);
  padding: 28px 22px;
  position: sticky;
  top: 62px;
  height: calc(100vh - 62px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* panel header */
.is__panel-hd {
  display: flex; align-items: center; gap: 10px; margin-bottom: 6px;
}
.is__panel-icon {
  width: 36px; height: 36px; border-radius: 11px; flex-shrink: 0;
  background: linear-gradient(135deg, #0a5556, #14b8a6);
  display: flex; align-items: center; justify-content: center;
  color: #fff;
  box-shadow: 0 4px 12px rgba(10,85,86,0.24);
}
.is__panel-title {
  font-family: 'Sora', sans-serif; font-size: 15px; font-weight: 800;
  color: #0f2a2a; letter-spacing: -0.02em;
}
.is__panel-sub {
  font-size: 12px; color: #9ababa; font-weight: 500; margin-bottom: 22px;
  padding-left: 46px;
}

/* template list */
.is__tpl-list { display: flex; flex-direction: column; gap: 10px; flex: 1; }

/* template card */
.is__tpl-card {
  border: 1.5px solid rgba(10,85,86,0.10);
  border-radius: 14px; overflow: hidden; cursor: pointer;
  transition: all 0.18s cubic-bezier(0.4,0,0.2,1);
  background: #fafefe;
  position: relative;
}
.is__tpl-card:hover {
  border-color: rgba(10,85,86,0.28);
  box-shadow: 0 4px 16px rgba(10,85,86,0.10);
  transform: translateY(-1px);
}
.is__tpl-card.active {
  border-color: #0a5556;
  background: #fff;
  box-shadow: 0 4px 20px rgba(10,85,86,0.16);
}

/* active indicator bar */
.is__tpl-card.active::before {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, #0a5556, #14b8a6);
  border-radius: 0 2px 2px 0;
}

/* mini preview strip */
.is__tpl-preview {
  height: 56px;
  border-bottom: 1px solid rgba(10,85,86,0.07);
  position: relative; overflow: hidden;
  background: var(--tpl-bg, #f4f9f9);
}
.is__tpl-preview-bar {
  position: absolute; top: 0; left: 0; right: 0;
  height: 4px;
  background: var(--tpl-accent);
}
.is__tpl-preview-lines {
  padding: 12px 14px 0;
  display: flex; flex-direction: column; gap: 5px;
}
.is__tpl-line {
  border-radius: 3px;
  height: 4px;
  background: var(--tpl-line, rgba(10,85,86,0.12));
}

/* card info row */
.is__tpl-info {
  display: flex; align-items: center; justify-content: space-between;
  padding: 11px 14px;
}
.is__tpl-name {
  font-family: 'Sora', sans-serif; font-size: 12.5px; font-weight: 800;
  color: #0f2a2a;
}
.is__tpl-desc { font-size: 11px; color: #9ababa; margin-top: 1px; }

.is__tpl-check {
  width: 22px; height: 22px; border-radius: 50%; border: 1.5px solid rgba(10,85,86,0.18);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  transition: all 0.15s ease;
}
.is__tpl-check.checked {
  background: linear-gradient(135deg, #0a5556, #14b8a6);
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(10,85,86,0.28);
}

/* save button */
.is__save-btn {
  width: 100%; padding: 13px 18px; border: none; border-radius: 13px; cursor: pointer;
  font-family: 'Sora', sans-serif; font-size: 13px; font-weight: 800;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  background: linear-gradient(135deg, #0a5556 0%, #0c7172 55%, #14b8a6 100%);
  color: #fff; margin-top: 20px;
  box-shadow: 0 4px 14px rgba(10,85,86,0.28);
  transition: all 0.18s ease;
  letter-spacing: 0.01em;
  position: relative; overflow: hidden;
}
.is__save-btn::after {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.15) 50%, transparent 100%);
  transform: translateX(-100%);
  transition: transform 0.5s ease;
}
.is__save-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 22px rgba(10,85,86,0.34); }
.is__save-btn:hover::after { transform: translateX(100%); }

/* ══════════════════════════════════════
   RIGHT — PREVIEW AREA
══════════════════════════════════════ */
.is__preview-area {
  flex: 1;
  min-width: 0;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
}

/* topbar of preview */
.is__preview-bar {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 20px; flex-shrink: 0;
}
.is__preview-left {
  display: flex; align-items: center; gap: 10px;
}
.is__live-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: #10b981;
  box-shadow: 0 0 0 3px rgba(16,185,129,0.20);
  animation: is__pulse 2s ease infinite;
}
@keyframes is__pulse {
  0%,100% { box-shadow: 0 0 0 3px rgba(16,185,129,0.20); }
  50%      { box-shadow: 0 0 0 6px rgba(16,185,129,0.08); }
}
.is__live-lbl {
  font-family: 'Sora', sans-serif; font-size: 11px; font-weight: 700;
  letter-spacing: 0.09em; text-transform: uppercase; color: #0a5556;
}
.is__preview-tag {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 5px 12px; border-radius: 8px;
  background: rgba(10,85,86,0.07); border: 1px solid rgba(10,85,86,0.12);
  font-family: 'Sora', sans-serif; font-size: 11px; font-weight: 700;
  color: #5a8080;
}

/* scroll container that shows A4 */
.is__viewer {
  flex: 1;
  background: #d8e5e5;
  border-radius: 18px;
  border: 1px solid rgba(10,85,86,0.10);
  padding: 32px;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-shadow: inset 0 2px 12px rgba(10,85,86,0.07);
}

/* scale the A4 paper to fit inside the viewer */
.is__scaler {
  transform-origin: top center;
  /* JS sets --scale; fallback keeps it readable */
  transform: scale(var(--preview-scale, 0.72));
  transition: transform 0.25s ease;
}

/* ── no-print ── */
@media print {
  .is__panel, .is__preview-bar, .is__preview-tag { display: none !important; }
  .is__viewer { background: none !important; padding: 0 !important; border: none !important; }
  .is__scaler { transform: none !important; }
}

@media (max-width: 900px) {
  .is__page { flex-direction: column; }
  .is__panel { width: 100%; height: auto; position: static; flex-direction: row; flex-wrap: wrap; padding: 16px; gap: 12px; }
  .is__tpl-list { flex-direction: row; overflow-x: auto; }
  .is__tpl-card { min-width: 160px; }
  .is__save-btn { margin-top: 0; }
  .is__preview-area { padding: 16px; }
}
`;

/* ─── Template config ─── */
const invoiceTemplates = [
  {
    id: 1, name: "Classic Blue", description: "Standard corporate look", color: "#0d47a1",
    accent: "linear-gradient(90deg,#0a5556,#14b8a6,#FFD166)",
    bg: "#f0f8f8", lineW: ["65%","45%","80%","30%"],
  },
  {
    id: 2, name: "Modern Minimal", description: "Clean and spacious design", color: "#1e293b",
    accent: "linear-gradient(90deg,#0a5556,#14b8a6,#FFD166)",
    bg: "#f4f9f9", lineW: ["55%","70%","40%","60%"],
  },
  {
    id: 3, name: "Professional", description: "Bold and high-contrast", color: "#1a73e8",
    accent: "linear-gradient(90deg,#0a3d3e,#0a5556,#0c7172)",
    bg: "#eef6f6", lineW: ["70%","50%","85%","35%"],
  },
  {
    id: 4, name: "Elegance", description: "Gold stripe luxury look", color: "#0a3d3e",
    accent: "linear-gradient(90deg,#0a3d3e,#1a6b5a,#FFD166)",
    bg: "#fafcfa", lineW: ["60%","80%","45%","65%"],
  },
  {
    id: 5, name: "Mosaic", description: "Diagonal split modern style", color: "#0a5556",
    accent: "linear-gradient(90deg,#FFD166,#14b8a6,#0a5556)",
    bg: "#f7fbfb", lineW: ["75%","55%","70%","40%"],
  },
  {
    id: 6, name: "Blueprint", description: "Mono type + stamp watermark", color: "#0a3d3e",
    accent: "linear-gradient(90deg,#FFD166,#f59e0b,#0a5556,#14b8a6)",
    bg: "#fefefe", lineW: ["60%","75%","45%","55%"],
  },
  {
    id: 7, name: "Noir", description: "Dark luxury gold edition", color: "#FFD166",
    accent: "linear-gradient(90deg,#0d1a1a,#1a3030,#FFD166,#f59e0b)",
    bg: "#0d1a1a", lineW: ["70%","50%","80%","40%"],
  },
];

/* ═══════════════════════════════════════════════════
   COMPONENT — ALL BACKEND LOGIC COMPLETELY UNCHANGED
═══════════════════════════════════════════════════ */
const Invoice = () => {
  const [selectedTemplateId, setSelectedTemplateId] = useState(1);
  const token = localStorage.getItem("auth_token");

  /* ── Toast (UNCHANGED) ── */
  const Toast = Swal.mixin({
    toast: true, position: "top-end", showConfirmButton: false,
    timer: 2000, timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  /* ── fetchSavedTemplate (UNCHANGED) ── */
  useEffect(() => {
    const fetchSavedTemplate = async () => {
      try {
        const res = await axios.get(`${baseurl}getBusinessInvoiceTemplate`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data.success && res.data.template_id) {
          setSelectedTemplateId(res.data.template_id);
        }
      } catch (err) {
        console.error("Failed to fetch saved template", err);
      }
    };
    fetchSavedTemplate();
  }, [token]);

  /* ── handlePrint (UNCHANGED) ── */
  const handlePrint = () => window.print();

  /* ── handleSaveTemplate (UNCHANGED) ── */
  const handleSaveTemplate = async () => {
    try {
      const payload = { template_id: selectedTemplateId };
      console.log("Sending template data to backend:", payload);
      const res = await axios.post(
        `${baseurl}saveBusinessInvoiceTemplate`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        Toast.fire({ icon: "success", title: "Your selected invoice template has been saved" });
      } else {
        Toast.fire({ icon: "error", title: res.data.message || "Failed to save template" });
      }
    } catch (err) {
      console.log("Error response:", err.response);
      Toast.fire({ icon: "error", title: err.response?.data?.message || "Failed to save template" });
    }
  };

  /* ── renderSelectedTemplate (UNCHANGED) ── */
  const renderSelectedTemplate = () => {
    switch (selectedTemplateId) {
      case 1: return <InvoiceOne />;
      case 2: return <InvoiceTwo />;
      case 3: return <InvoiceThree />;
      case 4: return <InvoiceFour />;
      case 5: return <InvoiceFive />;
      case 6: return <InvoiceSix />;
      case 7: return <InvoiceSeven />;
      default: return <InvoiceOne />;
    }
  };

  /* ── compute scale so A4 (794px wide) fits the viewer ── */
  const [scale, setScale] = React.useState(0.72);
  const viewerRef = React.useRef(null);
  useEffect(() => {
    const compute = () => {
      if (!viewerRef.current) return;
      const w = viewerRef.current.clientWidth - 64; // minus padding
      const a4px = 794; // 210mm at 96dpi
      setScale(Math.min(1, w / a4px));
    };
    compute();
    window.addEventListener("resize", compute);
    return () => window.removeEventListener("resize", compute);
  }, []);

  const activeTpl = invoiceTemplates.find(t => t.id === selectedTemplateId);

  /* ═══ RENDER ═══ */
  return (
    <>
      <style>{CSS}</style>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="is__page">

          {/* ════ LEFT PANEL ════ */}
          <aside className="is__panel no-print">

            {/* Header */}
            <div className="is__panel-hd">
              <div className="is__panel-icon"><FiLayout size={16} /></div>
              <div className="is__panel-title">Templates</div>
            </div>
            <div className="is__panel-sub">Choose a design for your invoice</div>

            {/* Template cards */}
            <div className="is__tpl-list">
              {invoiceTemplates.map((tpl) => {
                const isActive = selectedTemplateId === tpl.id;
                return (
                  <div
                    key={tpl.id}
                    className={`is__tpl-card ${isActive ? "active" : ""}`}
                    onClick={() => setSelectedTemplateId(tpl.id)}
                  >
                    {/* Mini preview */}
                    <div
                      className="is__tpl-preview"
                      style={{ "--tpl-bg": tpl.bg, "--tpl-accent": tpl.accent }}
                    >
                      <div className="is__tpl-preview-bar" style={{ background: tpl.accent }} />
                      <div className="is__tpl-preview-lines">
                        {tpl.lineW.map((w, i) => (
                          <div key={i} className="is__tpl-line" style={{ width: w, opacity: i === 0 ? 0.35 : 0.15 }} />
                        ))}
                      </div>
                    </div>

                    {/* Info row */}
                    <div className="is__tpl-info">
                      <div>
                        <div className="is__tpl-name">{tpl.name}</div>
                        <div className="is__tpl-desc">{tpl.description}</div>
                      </div>
                      <div className={`is__tpl-check ${isActive ? "checked" : ""}`}>
                        {isActive && <FiCheck size={11} color="#fff" />}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Save button */}
            <button className="is__save-btn" onClick={handleSaveTemplate}>
              <FiSave size={14} /> Save Template
            </button>

          </aside>

          {/* ════ PREVIEW AREA ════ */}
          <div className="is__preview-area">

            {/* Preview topbar */}
            <div className="is__preview-bar no-print">
              <div className="is__preview-left">
                <div className="is__live-dot" />
                <span className="is__live-lbl">Live Preview</span>
              </div>
              <div className="is__preview-tag">
                <FiEye size={11} /> A4 · 210mm × 297mm · {activeTpl?.name}
              </div>
            </div>

            {/* Viewer */}
            <div className="is__viewer" ref={viewerRef}>
              <div
                className="is__scaler"
                style={{ "--preview-scale": scale }}
              >
                {renderSelectedTemplate()}
              </div>
            </div>

          </div>

        </div>
      </main>
    </>
  );
};

export default Invoice;
